export default __webpack_public_path__ + "static/media/Head_1_Ear_2_C1.caffb4b7.svg";